import MonthPickerDialogForm from 'portal/src/components/common/MonthPickerDialogForm';
import { datePickerType } from 'portal/src/components/common/forms/FormFieldTypes';

const fieldConf: datePickerType = {
  placeholder: 'Score and Metrics Start Month',
  label: 'Score and Metrics Start Month',
  name: 'metricsStartMonth',
  type: 'datePicker',
  required: true,
  other: {
    views: ['year', 'month'],
  },
};

const ESScoreAndMetricsDialog = ({
  onClose,
  onSave,
  open,
}: {
  onClose: () => void;
  onSave: (data: any) => void;
  open: boolean;
}) => (
  <MonthPickerDialogForm
    title="Select start month for scores and metrics:"
    open={open}
    onClose={onClose}
    onSave={onSave}
    fieldConf={fieldConf}
    formId="facility-es-score-and-metrics-form"
    confirmLabel="Update"
  />
);

export default ESScoreAndMetricsDialog;
